import React from 'react';
import { Box, Typography } from '@mui/material';

import { useWidgetFrame } from '../frameContext';
import { labelSx, valueFontSize, valueSx } from './mobileText';

/** 2 x 2 mini tiles (design "KPI group"). items: [{ label, value, change: { text, down } }] */
export default function KpiGroupBody({ items = [] }) {
  const frame = useWidgetFrame();
  const mobile = Boolean(frame?.isMobile);
  return (
    <Box sx={{ flex: 1, minHeight: 0, p: 1.5, display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 1.25 }}>
      {items.slice(0, 4).map((item, index) => (
        <Box key={index} sx={{ border: '1px solid #e2e8f0', borderRadius: '10px', px: 1.5, py: 1.25, minWidth: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <Typography data-widget-value="" sx={{ fontSize: valueFontSize(item.value, mobile, 22), fontWeight: 700, letterSpacing: '-0.3px', fontFamily: "'Plus Jakarta Sans', sans-serif", ...valueSx(mobile) }}>
            {item.value}
          </Typography>
          {/* Label and change badge wrap independently: on a narrow cell the badge drops to its own line. */}
          <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'baseline', columnGap: 0.75, fontSize: 12, color: 'text.secondary', minWidth: 0 }}>
            <Typography component="span" sx={{ fontSize: 12, color: 'text.secondary', minWidth: 0, ...labelSx(mobile) }}>
              {item.label}
            </Typography>
            {item.change?.text ? (
              <Box component="span" sx={{ fontWeight: 600, whiteSpace: 'nowrap', color: item.change.down ? '#c53030' : '#2f8c54' }}>
                {item.change.text}
              </Box>
            ) : null}
          </Box>
        </Box>
      ))}
    </Box>
  );
}
